import {
  MaterialReactTable,
  MRT_EditActionButtons,
  useMaterialReactTable,
} from "material-react-table";
import {
  Box,
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  ThemeProvider,
  Tooltip,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import "./data-table.css";
import useTableTheme from "constants/TableTheme";

export default function DataTable({
  columns,
  data,
  getRowId,
  validationSchema = () => ({}),
  onCreate,
  onUpdate,
  onDelete,
  loadingStates = {},
  title = "Create Record",
  editTitle = "Edit Record",
}) {
  const {
    isLoading = false,
    isFetching = false,
    isCreating = false,
    isUpdating = false,
    isDeleting = false,
    isError = false,
  } = loadingStates;
  const tableTheme = useTableTheme();
  const table = useMaterialReactTable({
    columns,
    data,
    getRowId,
    createDisplayMode: "modal",
    editDisplayMode: "modal",
    enableEditing: true,
    positionActionsColumn: "last",
    enableRowActions: true,
    muiTableContainerProps: {
      className: "table-container",
    },
    initialState: {
      showGlobalFilter: true
    },
    onCreatingRowSave: async ({ values, table }) => {
      const errors = validationSchema(values);
      if (Object.values(errors).some(Boolean)) return;
      await onCreate(values);
      table.setCreatingRow(null);
    },
    onEditingRowSave: async ({ values, table }) => {
      const errors = validationSchema(values);
      if (Object.values(errors).some(Boolean)) return;
      await onUpdate(values);
      table.setEditingRow(null);
    },
    renderCreateRowDialogContent: ({ table, row, internalEditComponents }) => (
      <>
        <DialogTitle variant="h6">{title}</DialogTitle>
        <DialogContent
          sx={{ display: "flex", flexDirection: "column", gap: "1rem" }}
        >
          {internalEditComponents}
        </DialogContent>
        <DialogActions>
          <MRT_EditActionButtons table={table} row={row} />
        </DialogActions>
      </>
    ),
    renderEditRowDialogContent: ({ table, row, internalEditComponents }) => (
      <>
        <DialogTitle variant="h6">{editTitle}</DialogTitle>
        <DialogContent
          sx={{ display: "flex", flexDirection: "column", gap: "1rem" }}
        >
          {internalEditComponents}
        </DialogContent>
        <DialogActions>
          <MRT_EditActionButtons table={table} row={row} />
        </DialogActions>
      </>
    ),
    renderRowActions: ({ row, table }) => (
      <Box className="action-buttons">
        <Tooltip title="Edit">
          <IconButton size="small" onClick={() => table.setEditingRow(row)}>
            <EditIcon fontSize="small" />
          </IconButton>
        </Tooltip>
        <Tooltip title="Delete">
          <IconButton
            size="small"
            color="error"
            onClick={() => onDelete(row.original)}
          >
            <DeleteIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      </Box>
    ),

    renderTopToolbarCustomActions: ({ table }) => (
      <Button
        variant="contained"
        color="error"
        onClick={() => table.setCreatingRow(true)}
      >
        + Create New
      </Button>
    ),
    state: {
      isLoading,
      isSaving: isCreating || isUpdating || isDeleting,
      showAlertBanner: isError,
      showProgressBars: isFetching,
    },
    muiTablePaperProps: {
      elevation: 0,
      sx: {
        width: "100%",
        borderRadius: "0",
        backgroundColor: "#fff !important",
        zIndex: 500,
      },
    },
  });
  return (
    <ThemeProvider theme={tableTheme}>
      <MaterialReactTable
        table={table}
        filterVariant="multi-select"
        style={{ width: "100%" }}
      />
    </ThemeProvider>
  );
}
